/**
 * Time limits for alarm and trace display.
 *
 * Defines how long alarms and traces remain visible in the UI after activation.
 * Both default to 2 hours 15 minutes (8100 seconds). Wrapped in functions to
 * allow future configuration via settings or backend.
 *
 * @module limits
 */

/**
 * Maximum time an alarm is shown as active (seconds).
 * @returns 8100 (2h 15min)
 */
export const getMaxAlarmTimeS = (): number => {
  return 60 * 60 * 2 + 15 * 60;
};

/**
 * Maximum time a trace is shown as active (seconds).
 * @returns 8100 (2h 15min)
 */
export const getMaxTraceTimeS = (): number => {
  return 60 * 60 * 2 + 15 * 60;
};

/**
 * Maximum time a device is shown as active (seconds).
 * Matches the backend MAX_ACTIVE_AGE_S (6h) so the UI's green markers agree with
 * the server's active-age gate and a stale active flag never lingers forever.
 * @returns 21600 (6h)
 */
export const getMaxActiveTimeS = (): number => {
  return 60 * 60 * 6;
};
